import React, { useEffect, useState } from 'react'
import { Text, View, TextInput, TouchableOpacity, Keyboard, StatusBar, Image } from 'react-native'
import { FormContentsModel, ModelAnswerFromProps } from '../models/StoreDetailModel'
import theme from '../../../../theme'
import styles from './InputCommentItemStyles'
import { schedulesServices } from '../../../../database/schedules.database'
import { useBottomSheet } from '../../customUtils/context/BottomSheetContext'
import { close, snapPoint } from 'react-native-redash'
import { getLanguage } from '../../appBar/context/LocalizationContext'
import { ImageWithZoom } from '../../customUtils/Components/ImageWIthZoom'
import useImageLoader from '../../../hooks/useImageLoader'
import { PATH_ASSETS } from '../../../utils/Constants'
import { Loader } from '../../customUtils/Components/Loader'

interface InputCommentItemProps {
    item: FormContentsModel
    form_id: string
    schedule_id: string
    store_id: string
    checkComplete: (option?: ModelAnswerFromProps) => void
    keyboardHiddenState: boolean
    onFocus: (id: string) => void
    activeInputId: string
}

export const InputCommentItem = React.memo(
    ({ item, form_id, schedule_id, store_id, checkComplete, keyboardHiddenState, onFocus, activeInputId }: InputCommentItemProps) => {
        const { languageFile } = getLanguage()
        const [answer, setAnswer] = useState('')
        const { openBottomSheet, closeBottomSheet } = useBottomSheet()
        const { image, loading, placeholderGeneral } = useImageLoader(item.media, PATH_ASSETS)
        const [preview, setPreview] = useState(image)

        const [value, setValue] = useState('')
        const [canEditText, setCanEditText] = useState(false)

        useEffect(() => {
            if (item?.old_response) {
                setAnswer(item.old_response.question_input || '')
            }
        }, [item?.old_response])

        useEffect(() => {
            setPreview(image)
        }, [image])

        useEffect(() => {
            if (keyboardHiddenState && activeInputId == item._id) {
                if (answer !== '') {
                    handleTextChange(answer)
                }
            }
        }, [keyboardHiddenState])

        const create_answer = async (inputText: string) => {
            let answerScore = '0'
            if (item.score != null && item.score > 0 && inputText != '') answerScore = item.score.toString()
            const answer: ModelAnswerFromProps = {
                _id: item._id,
                option_selected_text: [],
                option_selected_id: [],
                question_id: item._id,
                media: '',
                question_text: item.title,
                score: answerScore,
                status: 1,
                date_finish: new Date().toString(),
                date_init: new Date().toString(),
                question_input: inputText,
                field_media: '',
                field_text: '',
                questionScore: item.questionScore,
                type: item.input_type.type,
                ponderar: item.score && item.score > 0, //[7, 8, 14, 18].includes(item.input_type.type),

                question: item.title,
                questionOptionSelected: [],
                questionOptionSelectedText: [],
                questionType: {
                    title: item.input_type.title,
                    type: item.input_type.type,
                    id: item.input_type._id,
                },
                questionPrice: '',
                description: '',
                tag: '',
                questionImage: '',
                questionInput: inputText,
            }

            await schedulesServices.updateFormAnswerSchedule(answer, schedule_id, form_id, store_id)
            await checkComplete(answer)
        }

        const openSheet = async () => {
            const isModalClosable = true
            const isModalClosableTouch = true
            const isModalClosableSlice = false
            const keyboardShouldPersistTaps = true
            openBottomSheet(
                <InputCommentSheet answer={answer} handleTextChange={handleTextChange} numeric={false} title={item.title} />,
                undefined,
                keyboardShouldPersistTaps,
                isModalClosable,
                isModalClosableSlice,
                isModalClosableTouch,
            )
        }

        const handleTextChange = (text: string) => {
            setAnswer(text)
            console.log('text', text)
            create_answer(text)
            // closeBottomSheet(true)
            // Keyboard.dismiss()
        }
        const openBigImage = () => {
            if (image) {
                openBottomSheet(<ImageWithZoom uri={image} contentSeen={() => {}} path={''} />, undefined, undefined, true, true, true)
            }
        }
        return (
            <View style={styles.flexDirection}>
                {item && (
                    <View style={{ flex: 1 }}>
                        <View style={styles.flexDirection}>
                            <TouchableOpacity onPress={() => openBigImage()}>
                                {item.media && item.media != '' && (
                                    <>
                                        {loading ? (
                                            <Loader />
                                        ) : (
                                            <Image
                                                style={styles.image}
                                                source={{ uri: preview }}
                                                resizeMode='contain'
                                                onError={(e) => {
                                                    setPreview(placeholderGeneral)
                                                }}
                                            />
                                        )}
                                    </>
                                )}
                            </TouchableOpacity>
                            <Text style={[styles.title, { flex: 1, paddingLeft: item.media && item.media != '' ? 0 : 15 }]}>{item.title}</Text>
                        </View>
                        <TextInput
                            // autoFocus={true}
                            style={styles.input}
                            onChangeText={(text) => setAnswer(text)}
                            onEndEditing={() => handleTextChange(answer)}
                            placeholder={languageFile.enter_a_comment}
                            value={answer}
                            placeholderTextColor={theme.colors.mediumGray}
                            keyboardType={'default'}
                            onSubmitEditing={() => handleTextChange(answer)}
                            onFocus={() => onFocus(item._id)}
                        />
                        <View style={styles.dividerHorizontalLine}></View>
                    </View>
                )}
            </View>
        )
    },
)

export const InputCommentSheet = ({
    answer,
    handleTextChange,
    numeric,
    title,
}: {
    answer: string
    handleTextChange: (text: string) => void
    numeric: boolean
    title: string
}) => {
    const [value, setValue] = useState(answer)

    const { languageFile } = getLanguage()

    const closeSheet = (text: string) => {
        console.log('Entro al close')
        // if (text.trim() != '') {
        handleTextChange(text)
        // }
        // Keyboard.dismiss()
    }
    return (
        <View style={styles.container}>
            {/* <StatusBar backgroundColor={'rgba(0, 0, 0, 0.7)'} barStyle='dark-content' /> */}
            <Text style={styles.title}>{title}</Text>
            <TextInput
                // onBlur={() => closeSheet(value)}
                style={styles.input}
                onChangeText={(text) => setValue(text)}
                placeholder={!numeric ? languageFile.enter_a_comment : languageFile.enter_a_value}
                value={value}
                placeholderTextColor={theme.colors.mediumGray}
                keyboardType={numeric ? 'numeric' : 'default'}
                onSubmitEditing={() => closeSheet(value)}
            />

            <View style={styles.buttonContainer}>
                <TouchableOpacity style={styles.borderButton} onPress={() => closeSheet(value)}>
                    <Text style={styles.borderButtonText}>{languageFile.confirm}</Text>
                </TouchableOpacity>
            </View>
        </View>
    )
}

export interface ActivityInput {
    _id: string
    title: string
    status: number
    created_date: string
    modified_date: string
    date_init: string
    date_finish: string
    days: Array<number>
    others_activities: boolean
    combo: boolean
    frequency: string
}

export const InputCommentActivity = ({
    answer,
    handleTextChange,
    numeric,
    title,
    activity,
    typeActivity,
}: {
    answer: string
    handleTextChange: (text: string, type_activity: string, activityId: string, activity: ActivityInput) => Promise<void>
    numeric: boolean
    title: string
    activity: ActivityInput
    typeActivity: string
}) => {
    const [value, setValue] = useState(answer)

    const { languageFile } = getLanguage()
    const BottomSheet = useBottomSheet()

    const closeSheet = (text: string) => {
        console.log('Entro al close')
        // if (text.trim() != '') {
        // handleTextChange(text)
        // }
        // Keyboard.dismiss()
        // BottomSheet.closeBottomSheet()
    }

    const handleSendComment = (text: string) => {
        // console.log('225 --- handleSendComment', text)
        handleTextChange(text, typeActivity, activity._id, activity)
    }
    return (
        <View style={styles.container}>
            {/* <StatusBar backgroundColor={'rgba(0, 0, 0, 0.7)'} barStyle='dark-content' /> */}
            <Text style={styles.header}>Realizaste "{title}"</Text>
            <Text style={styles.subtitle}>
                Una vez que hayas completado una actividad, tienes la opción de agregar una observación o comentario. {'\n'}
                {'\n'}Esto te permitirá registrar detalles importantes, reflexiones o cualquier información relevante sobre la tarea realizada.
            </Text>
            <View style={styles.spacer}></View>
            {/*<Text style={styles.title}>{title}</Text>*/}
            <TextInput
                // onBlur={() => closeSheet(value)}
                style={[styles.input, { height: 80, textAlignVertical: 'top' }]}
                onChangeText={(text) => setValue(text)}
                placeholder={!numeric ? languageFile.enter_a_comment : languageFile.enter_a_value}
                value={value}
                placeholderTextColor={theme.colors.mediumGray}
                keyboardType={numeric ? 'numeric' : 'default'}
                onSubmitEditing={() => closeSheet(value)}
                multiline={true}
            />

            <View style={styles.buttonContainer}>
                <TouchableOpacity style={styles.borderButton} onPress={() => handleSendComment(value)}>
                    <Text style={styles.borderButtonText}>{languageFile.accept}</Text>
                </TouchableOpacity>
                <TouchableOpacity style={styles.cancelButton} onPress={() => BottomSheet.closeBottomSheet(true)}>
                    <Text style={styles.cancelButtonText}>{languageFile.cancel}</Text>
                </TouchableOpacity>
            </View>
        </View>
    )
}
